// ⚠️ If you add or remove a table, don't forget to increment the database version number in the app.config.ts file.
export enum DataTableEnum {
  CACHE, // ⚠️ Used by data.service.ts
  STORAGE,
  ASSETS,
}
